import React, { Dispatch, SetStateAction } from "react";
import { NavigateFunction } from "react-router-dom";
import { ProjectCardInter } from "../../interface/interface";
import { formatDate, StateForm } from "../../lib/lib";
import FixBtn from "../FixBtn/FixBtn";
import PostDeleteSection from "../PostDeleteSection/PostDeleteSection";

type Props = {
  index: number;
  PostRemove: ((data: any, id: string) => void) | ((id: string) => void);
  setDeleteIndex: Dispatch<SetStateAction<string | undefined>>;
  DeleteIndex: string | undefined;
  data: ProjectCardInter;
  ProjectPause: ((id: string) => void) | undefined;
  navigate: NavigateFunction;
};

const StartCard = ({
  data,
  DeleteIndex,
  setDeleteIndex,
  PostRemove,
  ProjectPause,
  navigate,
}: Props) => {
  const {
    prjt_nm,
    leadr_usr_nm,
    rcrt_apply_en_at,
    prjt_sts_cd,
    prjt_id,
    tot_rcrt_cnt,
    usr_rcrt_cnt,
    prjt_type_cd,
    mtup_typ,
  } = data;
  return (
    <div className="start-card-comp">
      <div className="start-title">{prjt_nm}</div>
      <div className="start-time">{formatDate(rcrt_apply_en_at, "-")}</div>
      <div className="start-leader">{leadr_usr_nm}</div>
      <div className="start-number">
        {}
        {usr_rcrt_cnt}/{tot_rcrt_cnt}
      </div>
      <div className={`start-state ${prjt_sts_cd}`}>
        {StateForm(prjt_sts_cd)}
      </div>
      <div className="start-card-btn-wrapper">
        {prjt_sts_cd === "prjt_sts_rcrt_ing" ? (
          <button
            className="pause-btn"
            onClick={() => {
              if (ProjectPause) {
                ProjectPause(prjt_id);
              }
            }}
          >
            일시정지
          </button>
        ) : (
          <FixBtn
            link={`/${prjt_type_cd}/write/step/1`}
            state={{ prjt_id, prjt_sts_cd }}
            style={{
              color: "white",
              backgroundColor: "#0062ff",
            }}
          />
        )}
        <button
          className="detail-btn"
          onClick={() => {
            navigate(`/${prjt_type_cd}/user/list`, {
              state: data,
            });
          }}
        >
          상세보기
        </button>
      </div>
      <PostDeleteSection
        isOpen={DeleteIndex === prjt_id}
        ment="프로젝트를 삭제하시겠습니까?"
        index={prjt_id}
        setDeleteIndex={setDeleteIndex}
        data={prjt_id}
        PostRemove={PostRemove}
      />
    </div>
  );
};

export default StartCard;
